import {
  get,
  flow,
  toLower,
  replace,
  getOr,
} from 'lodash/fp';
import {
  transformAttributeValue,
  getAttributeValue,
  getAttributeValueOr,
} from '../../helpers/getAttributeValue';

import PostMeasureOptionsCookie from '../../models/postMeasureOptionsCookie';

const buildTags = (item) => {
  const tags = [
    flow(
      getAttributeValue('mountType'),
      toLower,
    )(item),
  ];

  const spacers = getAttributeValue('spacers')(item);
  if (spacers) {
    tags.push('spacer-block');
  }
  const holdDown = getAttributeValue('holdDownBrackets')(item);
  if (holdDown) {
    tags.push('hold-down');
  }

  return tags;
};

const getMeasurementAttributeValue = transformAttributeValue(replace(/\.0$/, ''));

export default itemId => (dispatch, getState) => {
  const { estimateBuilder } = getState();

  const item = get(`entities.items.byId.${itemId}`)(estimateBuilder);
  const designId = get('designId')(item);
  const design = get(`entities.estimates.byId.${designId}`)(estimateBuilder);
  const containerId = get('containerId')(item);
  const container = get(`entities.containers.byId.${containerId}`)(estimateBuilder);

  const cookie = new PostMeasureOptionsCookie();
  cookie.destination = 'estimates';
  cookie.jobUid = get('attributes.jobId', design);

  cookie.width = getMeasurementAttributeValue('width', item);
  cookie.height = getMeasurementAttributeValue('height', item);
  cookie.depth = getMeasurementAttributeValue('depth', item);
  cookie.quoteUid = designId;
  cookie.windowUid = get('itemId')(item);

  cookie.baseUrl = location.origin;
  cookie.redirectUrl = `/estimatebuilder/mandi/load/${designId}`;

  const roomLabel = get('charLabel')(container);
  const roomName = get('name')(container);
  const windowLabel = get('charLabel')(item);
  const windowName = `${roomLabel}${windowLabel} ${roomName}`.substr(0, 10);

  cookie.roomName = roomName;
  cookie.windowName = windowName;
  cookie.isPostMeasureMode = true;
  cookie.tags = buildTags(item);

  cookie.isSpecialtyShape = getAttributeValueOr(false, 'specialtyShape')(item);
  cookie.isCutout = getAttributeValueOr(false, 'isCutout')(item);
  cookie.measurementDate = getAttributeValue('measureDate')(item);
  cookie.windowDescription = `${roomLabel} Window ${windowLabel}`;
  cookie.propertyAddress = flow(
    getOr('{}', 'attributes.propertyAddress'),
    JSON.parse,
    addr => `${addr.line1}${addr.line2 ? ` ${addr.line2}` : ''}, ${addr.city}, ${addr.state}, ${addr.zipcode}`,
  )(design);

  cookie.save();

  return cookie;
};
